import _ from 'underscore';
import DateFormatter from 'utils/date/DateFormatter';
import DateParser from 'utils/date/DateParser';
import PartialModel from 'models/device/PartialModel';

export default PartialModel.extend({
    useCache: true,

    url: function() {
        return `/userprofile-service/userprofile/user-settings/${this.useCache ? '' : '?' + Date.now()}`;
    },

    backend: 'gcapi',

    initialize: function(args = { useCache: true }) {
        this.useCache = args.useCache;
    },

    getGender: function() {
        return this.get('userData').gender;
    },

    setGender: function(gender) {
        this.updateUserDataItem('gender', gender);
    },

    getWeight: function() {
        return this.get('userData').weight;
    },

    setWeight: function(weight) {
        this.updateUserDataItem('weight', weight);
    },

    getHeight: function() {
        return this.get('userData').height;
    },

    setHeight: function(height) {
        this.updateUserDataItem('height', height);
    },

    getBirthDate: function() {
        return this.get('userData').birthDate;
    },

    setBirthDate: function(dateStr) {
        if (dateStr === null) {
            this.updateUserDataItem('birthDate', dateStr);
        } else {
            this.updateUserDataItem('birthDate', DateFormatter.formatISODate(DateParser.parseISO(dateStr)));
        }
    },

    getActivityLevel: function() {
        return this.get('userData').activityLevel;
    },

    setActivityLevel: function(activityLevel) {
        this.updateUserDataItem('activityLevel', activityLevel);
    },

    getVO2MaxRunning: function() {
        return this.get('userData').vo2MaxRunning;
    },

    setVO2MaxRunning: function(vo2Max) {
        this.updateUserDataItem('vo2MaxRunning', vo2Max);
    },

    getVO2MaxCycling: function() {
        return this.get('userData').vo2MaxCycling;
    },

    setVO2MaxCycling: function(vo2Max) {
        this.updateUserDataItem('vo2MaxCycling', vo2Max);
    },

    getMeasurementSystem: function() {
        return this.get('userData').measurementSystem;
    },

    setMeasurementSystem: function(measurementSystem) {
        this.updateUserDataItem('measurementSystem', measurementSystem);
    },

    getHandedness: function() {
        return this.get('userData').handedness;
    },

    setHandedness: function(handedness) {
        return this.updateUserDataItem('handedness', handedness);
    },

    setTrainingStatusPausedDate: function(pausedDate) {
        return this.updateUserDataItem('trainingStatusPausedDate', pausedDate);
    },

    getSleepTime: function() {
        var sleepTime = this.getUserSleep() ? this.getUserSleep().sleepTime : null;

        if (sleepTime || sleepTime === 0) {
            return sleepTime;
        }

        return 79200; //10:00 PM
    },

    setSleepTime: function(sleepTime) {
        this.set({
            userSleep: {
                sleepTime: sleepTime
            }
        });
    },

    getWakeTime: function() {
        if (!this.getUserSleep() || !this.getUserSleep().wakeTime) {
            this.setWakeTime(21600); // 6:00 AM
            return 21600;
        }
        return this.getUserSleep().wakeTime;
    },

    setWakeTime: function(wakeTime) {
        this.set({
            userSleep: {
                wakeTime: wakeTime
            }
        });
    },

    getUserSleep: function() {
        if (this.get('userSleep')) {
            return this.get('userSleep');
        } else {
            this.userSleep = {};
        }
    },

    hasExternalBottomTime: function() {
        return this.get('userData') && typeof this.get('userData').externalBottomTime !== 'undefined'
            ? this.get('userData').externalBottomTime !== null
            : false;
    },

    getExternalBottomTime: function() {
        return this.get('userData') && typeof this.get('userData').externalBottomTime !== 'undefined'
            ? this.get('userData').externalBottomTime
            : 0;
    },

    setExternalBottomTime: function(externalBottomTime) {
        this.updateUserDataItem('externalBottomTime', externalBottomTime);
    },

    getMenstrualCycleTrackingFeatureData: function() {
        return this.get('userMenstrualCycleSettings');
    },

    isPregnancySetup: function() {
        // returns true if user has successfully setup a pregnancy
        return this.get('userMenstrualCycleSettings') && this.get('userMenstrualCycleSettings').pregnancySetup;
    },

    updateMenstrualCycleTrackingSettingsData: function(item, value) {
        var menstrualCycleData = {};
        menstrualCycleData[item] = value;

        this.set({
            userMenstrualCycleSettings: menstrualCycleData
        });
    },

    getHydrationUnit: function() {
        return this.get('userData') && typeof this.get('userData').hydrationMeasurementUnit !== 'undefined'
            ? this.get('userData').hydrationMeasurementUnit
            : this.getDefaultHydrationUnit();
    },

    getDefaultHydrationUnit: function() {
        return this.getMeasurementSystem() === MeasurementSystems.METRIC ? FluidTypes.ml : FluidTypes.cup;
    },

    getHydrationContainers: function() {
        return this.get('userData') && typeof this.get('userData').hydrationContainers !== 'undefined'
            ? this.get('userData').hydrationContainers
            : [];
    },

    getWheelchairModeEnabled: function() {
        if (!this.get('userData')) {
            return null;
        }
        return this.get('userData').wheelchairModeEnabled;
    },

    setWheelchairModeEnabled: function(wheelchairModeEnabled) {
        this.updateUserDataItem('wheelchairModeEnabled', wheelchairModeEnabled);
    },

    // Method to set properties on the userData object
    // Note: Because userData is nested inside of UserSettings, a clone of that object must be used when setting back to the model.
    // > Even if a userData attr has been set, Backbone will think a straight reference to the userData object hasn't changed and thus not fire the 'change' event
    updateUserDataItem: function(item, value) {
        var userData = {};
        userData[item] = value;

        this.set({
            userData: userData
        });
    }
});
